import React, {forwardRef, useImperativeHandle, useState} from 'react';
import HelperService from "../services/helper-service";
import Loading from "./loading";
import Section from "./section";
import {Modal} from "react-bootstrap";
import {CourseDifficulty, Sweatmeter} from "../utils/constants";
import StarRating from "./star-rating";
import {ClickableSlider} from "./clickable-slider";
import {useTrainerService} from "../services/trainer-service";


const CourseDetailModal = forwardRef( ({callback=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState([]);

  const trainerService = useTrainerService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (id) => {
    if (id){
      setLoading(true);

      let promises = [
        trainerService.getCourseDetail(id)
      ];

      Promise.all(promises).then(([_courseDetail])=>{
        setCourse(_courseDetail.course);
        setLoading(false);
      });
    }

    setShow(true);
  }

  const photosSliderSettings = {
    swipe: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const closeModal = () => setShow(false);

  const CourseDetailModalCell = function() {
    return (<>
        {course?.id && <div className="px-3 py-2 mb-4">

          {course?.gallery?.length > 0 && <div className="mb-5"><ClickableSlider {...photosSliderSettings}>
            {course.gallery.map(t => <React.Fragment key={t.id}>
                  {t.type === "VIDEO" &&
                      <div className={'card rounded-3 overflow-hidden mb-3'} style={{height: "400px"}}>
                        <video width="100%" height="400" poster={t.thumbnail} controls>
                          <source src={t.url} type="video/mp4"/>
                        </video>
                      </div>
                  }
                  {t.type === "PHOTO" &&
                      <div className={'card rounded-3 overflow-hidden mb-3'} style={{height: "400px"}}>
                        <img src={t.url} alt="" className="img-fit"/>
                      </div>
                  }
                </React.Fragment>
            )}
          </ClickableSlider></div>}

          <div className="mb-2">
            <h5>{course.name}</h5>
            {course?.categories?.length > 0 && <div>{course?.categories.map(c => c.name).join(', ')}</div>}
          </div>
          {course?.rating > 0 && <div className="mb-2"><StarRating rating={course?.rating} count={course?.ratingsCount} /></div>}
          <div className="text-secondary fs-7 mb-2 d-flex gap-3">
            {course?.sweatmeter &&
                <div className="d-flex align-items-center">
                  <span className="mdi mdi-water-outline fs-6"></span> {HelperService.getObjByKey(Object.values(Sweatmeter), 'val', course?.sweatmeter).label}
                </div>
            }
            {course?.difficulty &&
                <div className="d-flex align-items-center">
                  <span className="mdi mdi-arm-flex-outline fs-6"></span> {HelperService.getObjByKey(Object.values(CourseDifficulty), 'val', course?.difficulty).label}
                </div>
            }
          </div>
          <div>
            <h6>Description</h6>
            <p>{course.info}</p>
          </div>
          <div>
            <h6>Age</h6>
            <div>Minimum: {course?.age?.min ? course?.age?.min : '-'}</div>
            <div>Recommended: {course?.age?.recommended ? course?.age?.recommended : '-'}</div>
            <div>Maximum: {course?.age?.max ? course?.age?.max : '-'}</div>
          </div>
        </div>}
    </>);
  }

  return (
      <>
        <Modal size='xl' show={!!show} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <h4 className="header-stripe-blue col-sm-6 pb-1">{course?.name ? course.name : 'Course detail'}</h4>
          </Modal.Header>
          <Modal.Body className="p-5">
            <Section animation={HelperService.getRandomAnimation()}>
              <div className="row">

                {loading && <Loading/>}
                {!loading && <>
                  {!course?.id && <div className="col-sm-12"><p>Could not find the course you mentioned. It will appear
                    here as soon as we find it!</p></div>}
                  {course?.id && <>
                    <CourseDetailModalCell />
                  </>}
                </>}

              </div>
            </Section>
          </Modal.Body>
        </Modal>
      </>
  );
});

export default CourseDetailModal;
